export default __webpack_public_path__ + "d1a72ced9fc79506963a5ddb14a882cb.svg";